import "./ProgressSkeleton.css";

export const SchlStudentProgressSkeleton = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="teacher-bodycontent">
          {/* Back button */}
          <div className="mb-4 skeleton skeleton-btn" />

          {/* Top banner */}
          <div className="skeleton skeleton-banner mb-4" />

          {/* Overall progress card */}
          <div className="col-md-12 mb-4">
            <div className="skeleton-card">
              <div className="skeleton skeleton-chip" />

              <div className="row align-items-center mt-4">
                <div className="col-md-5 text-center">
                  <div className="skeleton skeleton-circle mx-auto" />
                </div>

                <div className="col-md-2 d-none d-md-flex justify-content-center">
                  <div className="skeleton skeleton-divider" />
                </div>

                <div className="col-md-5 text-center">
                  <div className="skeleton skeleton-text-lg mx-auto mb-2" />
                  <div className="skeleton skeleton-text-sm mx-auto" />
                </div>
              </div>
            </div>
          </div>

          {/* Table section */}
          <div className="col-md-12">
            <div className="skeleton skeleton-table-title mb-3" />

            <div className="bg-white p-4" style={{ borderRadius: "22px" }}>
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div className="skeleton-row" key={i}>
                  <div className="skeleton skeleton-cell" />
                  <div className="skeleton skeleton-cell center" />
                  <div className="skeleton skeleton-cell center" />
                  <div className="skeleton skeleton-cell small center" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
